export default __webpack_public_path__ + "static/media/spotify.1fce5cb6.png";